<template>
  <div></div>
</template>
<script>
import { commonDialog, warningNotify, commonNotify } from "@/utils/lib/toast";
import "@/utils/rem.js";

export default {
  created() {
    this.getWxPromise();
  },
  methods: {
    // 获取微信授权
    getWxPromise() {
      // return;
      this.$http
        .reqGetWxOauthToUrl(this.$baseConfig.getWxActiveCodeUrl)
        .then((res) => {
          location.href = res.item.wxoauth2url;
        })
        .catch((err) => {
          console.log("微信拉取授权=====>", err);
        });
    },
    // 关闭页面
    closePop() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.call("closeWindow");
        },
        false
      );
      //这个可以关闭ios系统的手机
      // eslint-disable-next-line no-undef
      WeixinJSBridge.call("closeWindow");
    },
  },
};
</script>
<style lang=""></style>
